import { OrbitProgress } from 'react-loading-indicators'

type Size = 'xxs' | 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl'

interface ActivityIndicatorProps {
  size: Size
}

const mapSize = (size: Size) => {
  switch (size) {
    case 'xxs':
      return 16
    case 'xs':
      return 24
    case 's':
      return 32
    case 'm':
      return 48
    case 'l':
      return 56
    case 'xl':
      return 64
    case 'xxl':
      return 88
  }
}

const ActivityIndicator = ({ size }: ActivityIndicatorProps) => (
  // divide by 5, as the size of the indicator is 5em
  <OrbitProgress color="#9dd2b0" style={{ fontSize: mapSize(size) / 5 }} />
)

export default ActivityIndicator
